// extracted by mini-css-extract-plugin
module.exports = {"module":"job-posting-module-job-posting-module-module-ee740620","noBorder":"job-posting-module-job-posting-module-noBorder-cca98dff"};